import "./AboutUs.module.css";
import Nagłówek from "@/reusable_sections/Header";
import FundamentySkutecznosci from "./sections/FundamentySkutecznosci";
import NumbersAndFacts from "./sections/NumbersAndFacts";
import ZajmijMiejsceWFotelu from "./sections/ZajmijMiejsceWFotelu";
import QuoteProcessInfographic from "./sections/QuoteProcessInfographic";
import ComplianceStandards from "./sections/ComplianceStandards";
import TrainerFooter from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Nagłówek />
      <FundamentySkutecznosci />
      <QuoteProcessInfographic />
      <ComplianceStandards />
      <NumbersAndFacts />
      <ZajmijMiejsceWFotelu />
      <TrainerFooter />
    </div>;
}